// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h80pB6 {
  background-color: #eef8ec;
  color: var(--text-neutral-dark);
  border: 1px solid var(--status-success);
  border-radius: var(--radius-s);
  padding: var(--spacing-0-5);
  font-size: 10px;
  font-weight: var(--font-weight-regular);
  line-height: normal;
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-0-5);
  align-self: flex-start;
}

.Du9la1 {
  width: 10px;
  height: 10px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/NewBadge/NewBadge.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,uCAAuC;EACvC,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".badge {\n  background-color: #eef8ec;\n  color: var(--text-neutral-dark);\n  border: 1px solid var(--status-success);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-0-5);\n  font-size: 10px;\n  font-weight: var(--font-weight-regular);\n  line-height: normal;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n  align-self: flex-start;\n}\n\n.icon {\n  width: 10px;\n  height: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `h80pB6`,
	"icon": `Du9la1`
};
module.exports = ___CSS_LOADER_EXPORT___;
